export default "__VITE_ASSET__BzwWyVYM__"